const chain = (value, ...fList) => {
    for (const fn of fList) {
        if (fn) {
            value = fn(value);
        }
    }
    return value;
};

exports.chain = chain;
exports.chain1 = chain;

const chain2 = (value, fList) => {
    for (const fn of fList) {
        if (fn) {
            value = fn(value);
        }
    }
    return value;
};

exports.chain2 = chain2;

const and = (...fList) => {
    return (...args) => {
        for (const fn of fList) {
            if (!fn(...args)) {
                return false;
            }
        }
        return true;
    };
};

exports.and = and;
